import { Role } from './role';

export class User {
  id: number | null;
  username: string;
  first_name: string;
  last_name: string | null;
  email: string;
  dealers: any[];
  public applications: Array<Applications>;
  public role: Role | null;
  token: string | null;
  added_on:Date; 
  updated_on: Date;
  active: boolean | null;
}

export class Applications {
  name: string;
  key: string;
  active: boolean;
}

export class NewDealer {
  pacode: string;
  logo_url: string;
  brand: string| null;
  friendly_name: string;
  friendly_url: string;
  account_number: string;
  region: string;
  onboarded_date: string| null;
  onboarded_by: string| null;
  deactivated_by: null;
  deactivated_date: string | null;
  active: boolean | null;
  template: string| null;
}

export class Dealers {
  pacode: string;
  brand: number;
  logo_url: string;
  friendly_url: string;
  onboarded_date: Date;
  onboarded_by: string;
  deactivated_date?: Date;
  deactivated_by?: string;
  active: boolean;
}

export interface Element {
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  show: boolean;
}
